import { InMemoryCache } from '@apollo/client';
import { appSnacksVar } from './app-snacks';

export const cache = new InMemoryCache({
  typePolicies: {
    Models: {
      merge: true,
    },
    Query: {
      fields: {
        appSnacks: {
          read() {
            return appSnacksVar();
          },
        },
      },
    },
  },
  resultCaching: true,
});
